import styled, { css } from 'styled-components';

export const CustomText = styled.span<{
  color: string;
  margin?: string;
  lineHeight?: string;
  fontSize?: string;
  fontWeight?: string;
}>`
  ${({ theme, color, fontWeight, lineHeight, fontSize }) => css`
    font-size: ${fontSize || theme.font.sizes.small};
    color: ${color};
    font-weight: ${fontWeight || 700};
    line-height: ${lineHeight || '24px'};
  `}
`;
export const HeaderWrapper = styled.div`
  ${() => css`
    display: flex;
    gap: 0.8rem;
  `}
`;

export const WrapperTitle = styled.div`
  ${() => css`
    margin-bottom: 2.4rem;
  `}
`;

export const WrapperBanner = styled.div`
  ${() => css`
    margin: 0 0 1.6rem 0;
  `}
`;
export const ProgressBar = styled.div<{ percentage: string }>`
  ${({ percentage }) => css`
    width: 100%;
    height: 8px;
    border-radius: 4px;
    background: #f5f5f5;
    position: relative;
    margin: 1rem 0;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: ${percentage}%;
      height: 100%;
      border-radius: 4px;
      background: linear-gradient(to right, #298ee6, #1a344d);
    }

    ${percentage === '100' &&
    css`
      display: flex;
      align-items: center;
      justify-content: flex-end;

      svg {
        position: absolute;
        right: -4px;
        z-index: 1;
      }
    `}
  `}
`;
export const TextAsideSpan = styled.span<{
  fontWeight?: string;
  color?: string;
  fontSize?: string;
  cursor?: boolean;
}>`
  ${({ fontWeight, color, fontSize, cursor }) => css`
    font-size: ${fontSize ? `${fontSize}px` : '16px'};
    line-height: 24px;
    letter-spacing: -0.4px;
    color: ${color ? color : 'black'};
    font-weight: ${fontWeight ? fontWeight : '500'};
    cursor: ${cursor ? 'pointer' : 'default'};
    svg {
      margin-right: 16px;
    }
  `}
`;
export const BodyContentWrapper = styled.div`
  ${() => css`
    display: grid;
    grid-template-columns: 400px 1fr; /* Primeira coluna com no máximo 400px */
    gap: 2.4rem;
    margin-top: 1.6rem;

    @media (max-width: 1024px) {
      grid-template-columns: 1fr; /* Quando a tela for menor que 1024px, o layout vira uma coluna */
    }
  `}
`;

export const WrapperHistoryOfQualification = styled.div`
  ${() => css`
    margin-bottom: 2.4rem;
  `}
`;

export const WrapperDescription = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 9.6rem 15rem 10rem 1fr; /* As colunas permanecem com largura fixa */
    gap: 9.3rem;
    padding: 1.6rem 0;
    border-bottom: 1px solid ${theme.colors.neutral.neutral5};

    p {
      font-size: ${theme.font.sizes.medium};
      text-align: left; /* Garantir que o texto fique alinhado à esquerda */
    }

    /* Responsividade: Ajustar tamanho das fontes e espaçamento */
    @media (max-width: 1024px) {
      grid-template-columns: 9.6rem 12rem 8rem 1fr; /* Reduzir um pouco a largura das colunas */
      gap: 5rem; /* Reduzir o espaçamento */
      padding: 1.2rem 0; /* Diminuir o padding */

      p {
        font-size: ${theme.font.sizes.small}; /* Diminuir o tamanho da fonte */
      }
    }

    @media (max-width: 768px) {
      grid-template-columns: 7rem 10rem 6rem 1fr; /* Reduzir ainda mais as larguras das colunas */
      gap: 3rem; /* Menor espaçamento entre as colunas */
      padding: 1rem 0; /* Diminuir ainda mais o padding */

      p {
        font-size: ${theme.font.sizes.small}; /* Reduzir o tamanho da fonte */
      }
    }

    @media (max-width: 480px) {
      grid-template-columns: 6rem 8rem 5rem 1fr; /* Diminuir mais as larguras das colunas */
      gap: 2rem; /* Reduzir o espaçamento ainda mais */
      padding: 0.8rem 0; /* Ajustar o padding para telas muito pequenas */

      p {
        font-size: ${theme.font.sizes
          .xsmall}; /* Fonte ainda menor para telas muito pequenas */
      }
    }
  `}
`;
export const Ul = styled.ul`
  ${({ theme }) => css`
    list-style: none;
    padding: 0;
    li {
      display: flex;
      justify-content: space-between;
      font-size: ${theme.font.sizes.medium};
      color: ${theme.colors.neutral.neutral130};
      line-height: 2.4rem;
      letter-spacing: -0.4px;
      font-weight: 500;

      p {
        color: ${theme.colors.neutral.neutral40};
        font-weight: 700;
      }
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 2.6rem;
  `}
`;

export const WrapperPerformance = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 2rem;
    align-items: center;

    span {
      font-size: ${theme.font.sizes.large};
      font-weight: 600;
      line-height: 2.4rem;
      letter-spacing: -0.4px;
    }

    p {
      display: flex;
      justify-content: space-between;
      font-size: ${theme.font.sizes.medium};
      color: ${theme.colors.neutral.neutral130};
      line-height: 2.4rem;
      letter-spacing: -0.4px;
      font-weight: 500;
    }
  `}
`;

export const WrapperAside = styled.div`
  ${({ theme }) => css`
    > aside:first-child {
      margin-bottom: 1.6rem;
    }
    p {
      display: flex;
      justify-content: space-between;
      font-size: ${theme.font.sizes.medium};
      color: ${theme.colors.neutral.neutral130};
      line-height: 2.4rem;
      letter-spacing: -0.4px;
      font-weight: 500;
    }
  `}
`;

export const contentAside = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.neutral.neutral0};
    border-radius: ${theme.border.radius};
    padding: 24px;
  `}
`;
export const TitleAside = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  .title {
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.4px;
    font-weight: 600;
  }
`;
export const Grid = styled.div`
  display: grid;
  margin-bottom: 16px;
  grid-template-columns: repeat(2, 1fr); /* 2 colunas */
  gap: 8px; /* Espaçamento entre os itens */

  @media (max-width: 800px) {
    grid-template-columns: 1fr; /* 1 coluna quando a largura for menor que 800px */
  }
`;
export const GridInfos = styled.div`
  display: grid;
  margin-top: 16px;
  grid-template-columns: repeat(3, 1fr); /* 2 colunas */
  gap: 8px; /* Espaçamento entre os itens */

  @media (max-width: 800px) {
    grid-template-columns: 1fr; /* 1 coluna quando a largura for menor que 800px */
  }
`;
export const TextAside = styled.div<{
  fontWeight?: string;
  color?: string;
  fontSize?: string;
  cursor?: boolean;
}>`
  ${({ fontWeight, color, fontSize, cursor }) => css`
    font-size: ${fontSize ? `${fontSize}px` : '16px'};
    line-height: 24px;
    letter-spacing: -0.4px;
    color: ${color ? color : 'black'};
    font-weight: ${fontWeight ? fontWeight : '500'};
    cursor: ${cursor ? 'pointer' : 'default'};
    svg {
      margin-right: 16px;
    }
  `}
`;
export const WrapperMain = styled.main`
  ${() => css`
    width: 100%;

    > div {
      margin-bottom: 2rem;
    }
  `}
`;

export const WrapperButtonVerMais = styled.div`
  ${() => css`
    display: flex;
    justify-content: center;
  `}
`;

export const WrapperAmountQualification = styled.div`
  ${() => css`
    display: flex;
    gap: 4rem;
    @media (max-width: 800px) {
      display: none;
    }
  `}
`;

export const MyComponent = styled.div`
  ${() => css`
    fontSize: 2rem,
    font-weight: 600;
    `}
`;
